export default __webpack_public_path__ + "static/media/pablo.98f31196.png";